export const selectThemes = (state) => state.discovery.themes;

export const selectConfig = (state) => state.discovery.config;

export const selectDocuments = (state) =>
  state.discovery.themes[0]?.Documents || [];

export const selectOccurrences = (state) =>
  state.discovery.themes[0]?.Occurrences || 0;

export const selectContent = (state) => state.discovery.content;

export const selectSnapshots = (state) => state.discovery.snapshots;

export const selectAddToDictPanel = (state) => state.discovery.addToDictPanel;
